export enum ExpandableComponent {
  ORDER_SUMMARY = 'order-summary',
  VERTICAL_PAYMENT_SCHEDULE = 'vertical-payment-schedule-accordion',
  SHIPPING_ADDRESS_INLINE = 'shipping-address-inline-accordion',
  PAYMENT_METHOD_INLINE = 'payment-method-inline',
  SHIPPING_OPTION = 'shipping-option-accordion',
  PREFERRED_PAYMENT_DAY_INLINE = 'preferred-payment-day-inline-accordion',
}

export enum LimitedViewElementId {
  APPLE_RETAIL_DOWNPAYMENT = 'APPLE_RETAIL_DOWNPAYMENT',
}
export interface LimitedViewElement {
  maxView: number
  view: number
}

const limitedViewElementVault: Record<LimitedViewElementId, LimitedViewElement> = {
  [LimitedViewElementId.APPLE_RETAIL_DOWNPAYMENT]: { view: 0, maxView: 1 },
}

export const createLimitedViewElementControl = (): Record<LimitedViewElementId, LimitedViewElement> => ({
  ...limitedViewElementVault,
})
